import { StoryblokComponent } from "gatsby-source-storyblok"

import ArticleSection from "@components/V2/Layouts/ArticleSection"
import { Color } from "@constants/V2/color"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokArticleSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ArticleSection>) => {
  const backgroundColor = blok.backgroundColor || Color.White

  return (
    <ArticleSection
      title={blok.title}
      publicationInfo={blok.publicationInfo}
      ctaText={blok.ctaText}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      socialLinks={blok.socialLinks}
      backgroundColor={backgroundColor}
    >
      {blok.articleItems?.map((blok) => (
        <StoryblokComponent
          key={blok._uid}
          blok={blok}
          backgroundColor={backgroundColor}
        />
      ))}
    </ArticleSection>
  )
}

export default StoryblokArticleSection
